import React, {useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {Header} from '../../componentsRef/Header'
import settingUser from '../../assets/img/setting-user.svg'
import settingCircle2 from '../../assets/img/setting-circle-2.svg'
import settingCircle1 from '../../assets/img/setting-circle-1.svg'
import {envVariables} from '../../utils/envVariables/envVariables'
import {AvatarInitials} from '../../components/AvatarInitials'

import '../../assets/css/setting.css'

export const Settings = () => {
	const [otp, setOtp] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [otpRequested, setOtpRequested] = useState(false)
	const [loadingOtp, setLoadingOtp] = useState(false)
	const [loadingConfirm, setLoadingConfirm] = useState(false)
	const [avatarUrl, setAvatarUrl] = useState(localStorage.getItem('url_foto') || localStorage.getItem('avatar_url') || '')
	const [loadingAvatar, setLoadingAvatar] = useState(false)
	const [avatarError, setAvatarError] = useState('')
	const fileInputRef = useRef(null)

	const token = localStorage.getItem('token') || ''
	const userName = `${localStorage.getItem('nameUser') || ''} ${
		localStorage.getItem('lastName') || ''
	}`.trim()
	const userRole = localStorage.getItem('rol') || 'Usuario'
	const email = localStorage.getItem('email') || ''

	const resolveAvatarUrl = (value) => {
		if (!value) return ''
		if (/^https?:\/\//i.test(value) || String(value).startsWith('data:')) {
			return value
		}
		return `${envVariables.baseUrl.replace(/\/$/, '')}/${String(value).replace(/^\//, '')}`
	}

	const getAvatarFromUserInfo = (data) => {
		return (
			data?.url_foto ||
			data?.avatar_url ||
			data?.url_photo ||
			data?.photo_url ||
			data?.photoUrl ||
			data?.avatar ||
			data?.user_data?.url_foto ||
			data?.user_data?.avatar_url ||
			data?.user_data?.photo_url ||
			data?.user?.url_foto ||
			data?.user?.avatar_url ||
			data?.user?.photo_url ||
			''
		)
	}

	const refreshUserInfo = async () => {
		if (!token) return

		try {
			setAvatarError('')
			const response = await fetch(`${envVariables.baseUrl}/user/info`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})

			if (!response.ok) {
				throw new Error(await getErrorMessage(response))
			}

			const data = await response.json()
			const nextAvatarUrl = resolveAvatarUrl(getAvatarFromUserInfo(data))
			setAvatarUrl(nextAvatarUrl)

			if (nextAvatarUrl) {
				localStorage.setItem('url_foto', nextAvatarUrl)
				localStorage.setItem('avatar_url', nextAvatarUrl)
				localStorage.removeItem('urlPhoto')
				localStorage.removeItem('photoUrl')
			} else {
				localStorage.removeItem('url_foto')
				localStorage.removeItem('avatar_url')
				localStorage.removeItem('urlPhoto')
				localStorage.removeItem('photoUrl')
			}
		} catch (error) {
			console.error('Error al obtener avatar:', error)
			setAvatarError(error?.message || 'No se pudo cargar la imagen de perfil.')
		}
	}

	useEffect(() => {
		refreshUserInfo()
	}, [])

	useEffect(() => {
		const rootElement = document.getElementById('root')
		const previousBodyOverflow = document.body.style.overflow
		const previousBodyOverflowY = document.body.style.overflowY
		const previousBodyHeight = document.body.style.height
		const previousBodyMinHeight = document.body.style.minHeight
		const previousHtmlOverflow = document.documentElement.style.overflow
		const previousHtmlOverflowY = document.documentElement.style.overflowY
		const previousHtmlHeight = document.documentElement.style.height
		const previousRootOverflow = rootElement?.style.overflow || ''
		const previousRootHeight = rootElement?.style.height || ''
		const previousRootMinHeight = rootElement?.style.minHeight || ''

		document.documentElement.style.height = 'auto'
		document.documentElement.style.overflow = 'auto'
		document.documentElement.style.overflowY = 'auto'
		document.body.style.overflow = 'auto'
		document.body.style.overflowY = 'auto'
		document.body.style.minHeight = '100vh'
		document.body.style.height = 'auto'

		if (rootElement) {
			rootElement.style.overflow = 'visible'
			rootElement.style.height = 'auto'
			rootElement.style.minHeight = '100vh'
		}

		return () => {
			document.body.style.overflow = previousBodyOverflow
			document.body.style.overflowY = previousBodyOverflowY
			document.body.style.height = previousBodyHeight
			document.body.style.minHeight = previousBodyMinHeight
			document.documentElement.style.overflow = previousHtmlOverflow
			document.documentElement.style.overflowY = previousHtmlOverflowY
			document.documentElement.style.height = previousHtmlHeight

			if (rootElement) {
				rootElement.style.overflow = previousRootOverflow
				rootElement.style.height = previousRootHeight
				rootElement.style.minHeight = previousRootMinHeight
			}
		}
	}, [])

	const getErrorMessage = async (response) => {
		try {
			const data = await response.json()
			return data?.message || data?.error || 'No se pudo completar la solicitud.'
		} catch (error) {
			return 'No se pudo completar la solicitud.'
		}
	}

	const uploadAvatar = async (event) => {
		const file = event.target.files?.[0]
		if (!file) return

		const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp']
		if (!allowedTypes.includes(file.type)) {
			alert('Selecciona una imagen PNG, JPG o WEBP.')
			event.target.value = ''
			return
		}

		if (!token) {
			alert('No se encontró una sesión activa. Inicia sesión nuevamente.')
			event.target.value = ''
			return
		}

		try {
			setLoadingAvatar(true)
			setAvatarError('')
			const formData = new FormData()
			formData.append('photo', file)

			const response = await fetch(`${envVariables.baseUrl}/user/photo`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				body: formData,
			})

			if (!response.ok) {
				throw new Error(await getErrorMessage(response))
			}

			await refreshUserInfo()

			alert('Imagen de perfil actualizada correctamente.')
		} catch (error) {
			console.error('Error al actualizar avatar:', error)
			alert(error?.message || 'No se pudo actualizar la imagen de perfil.')
			setAvatarError(error?.message || 'No se pudo actualizar la imagen de perfil.')
		} finally {
			setLoadingAvatar(false)
			event.target.value = ''
		}
	}

	const deleteAvatar = async () => {
		if (!avatarUrl) return

		if (!token) {
			alert('No se encontró una sesión activa. Inicia sesión nuevamente.')
			return
		}

		const shouldDelete = window.confirm('¿Quieres eliminar tu imagen de perfil?')
		if (!shouldDelete) return

		try {
			setLoadingAvatar(true)
			setAvatarError('')
			const response = await fetch(`${envVariables.baseUrl}/user/photo`, {
				method: 'DELETE',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})

			if (!response.ok) {
				throw new Error(await getErrorMessage(response))
			}

			setAvatarUrl('')
			localStorage.removeItem('url_foto')
			localStorage.removeItem('avatar_url')
			localStorage.removeItem('urlPhoto')
			localStorage.removeItem('photoUrl')
			await refreshUserInfo()
			alert('Imagen de perfil eliminada correctamente.')
		} catch (error) {
			console.error('Error al eliminar avatar:', error)
			alert(error?.message || 'No se pudo eliminar la imagen de perfil.')
			setAvatarError(error?.message || 'No se pudo eliminar la imagen de perfil.')
		} finally {
			setLoadingAvatar(false)
		}
	}

	const requestOtp = async () => {
		if (!token) {
			alert('No se encontró una sesión activa. Inicia sesión nuevamente.')
			return
		}

		try {
			setLoadingOtp(true)
			const response = await fetch(
				`${envVariables.baseUrl}/user/password-update/otp/request`,
				{
					method: 'POST',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)

			if (!response.ok) {
				throw new Error(await getErrorMessage(response))
			}

			setOtpRequested(true)
			alert('OTP enviado al correo del usuario.')
		} catch (error) {
			console.error('Error al solicitar OTP:', error)
			alert(error?.message || 'No se pudo enviar el OTP. Intenta nuevamente.')
		} finally {
			setLoadingOtp(false)
		}
	}

	const confirmPasswordChange = async () => {
		if (!otp.trim()) {
			alert('Ingresa el código OTP enviado a tu correo.')
			return
		}

		if (!password || !confirmPassword) {
			alert('Ingresa y confirma tu nueva contraseña.')
			return
		}

		if (password !== confirmPassword) {
			alert('Las contraseñas no coinciden.')
			return
		}

		if (!token) {
			alert('No se encontró una sesión activa. Inicia sesión nuevamente.')
			return
		}

		try {
			setLoadingConfirm(true)
			const response = await fetch(
				`${envVariables.baseUrl}/user/password-update/otp/confirm`,
				{
					method: 'POST',
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						otp: otp.trim(),
						password,
					}),
				}
			)

			if (!response.ok) {
				throw new Error(await getErrorMessage(response))
			}

			setOtp('')
			setPassword('')
			setConfirmPassword('')
			setOtpRequested(false)
			alert('Contraseña actualizada correctamente.')
		} catch (error) {
			console.error('Error al cambiar contraseña:', error)
			alert(error?.message || 'No se pudo actualizar la contraseña.')
		} finally {
			setLoadingConfirm(false)
		}
	}

	return (
		<div className='HomeNew settings'>
			<img src={settingCircle1} className='circle-1-setting' alt='' />
			<img src={settingCircle2} className='circle-2-setting' alt='' />

			<Header />

			<div className='inner-header-setting'>
				<div>
					<img src={settingUser} alt='' />
					<p>Configuración de Perfil</p>
				</div>
			</div>

			<div className='step1 settings-profile-card'>
				<div className='profile-area'>
					<div className='profile-pic settings-profile-pic'>
						{avatarUrl ? (
							<img src={avatarUrl} alt='Imagen de perfil' />
						) : (
							<div className='settings-avatar-placeholder'>
								<AvatarInitials name={userName || email || 'Usuario'} size={86} />
							</div>
						)}
						<button
							type='button'
							className='settings-avatar-overlay'
							onClick={() => fileInputRef.current?.click()}
							disabled={loadingAvatar}
						>
							{loadingAvatar ? 'Procesando...' : 'Cambiar foto'}
						</button>
						<input
							ref={fileInputRef}
							type='file'
							accept='image/png,image/jpeg,image/jpg,image/webp'
							onChange={uploadAvatar}
							hidden
						/>
					</div>
					<div className='presentation-area settings-presentation-area'>
						<h1>{userName || 'Usuario'}</h1>
						<p>{userRole}</p>
						<div className='settings-avatar-actions'>
							<button
								type='button'
								onClick={() => fileInputRef.current?.click()}
								disabled={loadingAvatar}
							>
								Agregar / Cambiar
							</button>
							<button
								type='button'
								className='delete'
								onClick={deleteAvatar}
								disabled={loadingAvatar || !avatarUrl}
							>
								Eliminar
							</button>
						</div>
						{avatarError && <span className='settings-avatar-error'>{avatarError}</span>}
					</div>
				</div>

				<div className='inputs-area settings-inputs-area'>
					<div className='input-wrapper'>
						<label htmlFor='settings-email'>Email</label>
						<div className='flex-area-input'>
							<input
								type='text'
								id='settings-email'
								value={email}
								readOnly
								className='settings-readonly-input'
							/>
						</div>
					</div>

					<div className='settings-password-title'>
						<h2>Cambiar Contraseña</h2>
						<div className='settings-password-help'>
							<button type='button' aria-label='Ver pasos para cambiar contraseña'>
								?
							</button>
							<div className='settings-password-tooltip' role='tooltip'>
								<p>1. Presiona “Enviar código OTP” para recibir el código en tu correo.</p>
								<p>2. Ingresa el código OTP recibido.</p>
								<p>3. Escribe y confirma tu nueva contraseña.</p>
								<p>4. Presiona “Cambiar contraseña” para guardar el cambio.</p>
							</div>
						</div>
					</div>

					<div className='input-wrapper'>
						<label htmlFor='settings-otp'>Código OTP</label>
						<div className='settings-password-row'>
							<input
								type='text'
								id='settings-otp'
								value={otp}
								onChange={(event) => setOtp(event.target.value)}
								placeholder='Ingresa el código recibido'
								disabled={!otpRequested || loadingConfirm}
							/>
							<button
								type='button'
								onClick={requestOtp}
								disabled={loadingOtp || loadingConfirm}
							>
								{loadingOtp ? 'Enviando...' : 'Enviar código OTP'}
							</button>
						</div>
					</div>

					<div className='input-wrapper'>
						<label htmlFor='settings-password'>Nueva contraseña</label>
						<div className='settings-password-row single'>
							<input
								type='password'
								id='settings-password'
								value={password}
								onChange={(event) => setPassword(event.target.value)}
								placeholder='Ingresa tu nueva contraseña'
								disabled={!otpRequested || loadingConfirm}
							/>
						</div>
					</div>

					<div className='input-wrapper'>
						<label htmlFor='settings-confirm-password'>Confirmar contraseña</label>
						<div className='settings-password-row single'>
							<input
								type='password'
								id='settings-confirm-password'
								value={confirmPassword}
								onChange={(event) => setConfirmPassword(event.target.value)}
								placeholder='Repite tu nueva contraseña'
								disabled={!otpRequested || loadingConfirm}
							/>
						</div>
					</div>

					<button
						type='button'
						className='settings-change-password-button'
						onClick={confirmPasswordChange}
						disabled={!otpRequested || loadingConfirm}
					>
						{loadingConfirm ? 'Actualizando...' : 'Cambiar contraseña'}
					</button>
				</div>
			</div>

			<Link to='/HomeNew' className='back-top-button settings-back-link'>
				<svg
					width='12'
					height='12'
					viewBox='0 0 12 12'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M4.01321 9.57498C3.85487 9.57498 3.72154 9.51865 3.61321 9.40598C3.50487 9.29365 3.45071 9.15832 3.45071 8.99998C3.45071 8.84165 3.50487 8.70632 3.61321 8.59398C3.72154 8.48132 3.85487 8.42498 4.01321 8.42498H7.06321C7.57154 8.42498 8.01321 8.26665 8.38821 7.94998C8.76321 7.63332 8.95071 7.23331 8.95071 6.74998C8.95071 6.26665 8.76321 5.86665 8.38821 5.54998C8.01321 5.23332 7.57154 5.07498 7.06321 5.07498H4.07571L4.91321 5.89998C5.02154 6.00832 5.07571 6.14165 5.07571 6.29998C5.07571 6.45832 5.02154 6.59165 4.91321 6.69998C4.80487 6.80831 4.67154 6.86248 4.51321 6.86248C4.35487 6.86248 4.22154 6.80831 4.11321 6.69998L2.31321 4.89998C2.26321 4.84165 2.22571 4.77915 2.20071 4.71248C2.17571 4.64582 2.16321 4.57498 2.16321 4.49998C2.16321 4.42498 2.17571 4.35415 2.20071 4.28748C2.22571 4.22081 2.26321 4.15831 2.31321 4.09998L4.11321 2.29998C4.22154 2.19165 4.35487 2.13748 4.51321 2.13748C4.67154 2.13748 4.80487 2.19165 4.91321 2.29998C5.02154 2.40831 5.07571 2.54165 5.07571 2.69998C5.07571 2.85831 5.02154 2.99165 4.91321 3.09998L4.07571 3.92498H7.06321C7.88821 3.92498 8.59871 4.19582 9.19471 4.73748C9.79038 5.27915 10.0882 5.94998 10.0882 6.74998C10.0882 7.54998 9.79038 8.22082 9.19471 8.76248C8.59871 9.30415 7.88821 9.57498 7.06321 9.57498H4.01321Z'
						fill='#3676F5'
					/>
				</svg>
				Volver al Inicio
			</Link>
		</div>
	)
}
